(function () {
  'use strict';

  function slugify(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 72) || 'article-section';
  }

  function buildToc(root, content) {
    var toc = root.querySelector('[data-lnaf-toc]');
    if (!toc) return [];
    var used = {};
    var headings = Array.prototype.slice.call(content.querySelectorAll('h2'));

    headings.forEach(function (heading, index) {
      var base = heading.id || slugify(heading.textContent);
      var candidate = base;
      var suffix = 2;
      while (used[candidate] || document.getElementById(candidate)) {
        candidate = base + '-' + suffix;
        suffix += 1;
      }
      used[candidate] = true;
      heading.id = candidate;

      var link = document.createElement('a');
      link.href = '#' + candidate;
      link.textContent = heading.textContent.trim();
      link.dataset.lnafTocLink = candidate;
      toc.appendChild(link);
    });

    if ('IntersectionObserver' in window && headings.length) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          toc.querySelectorAll('a').forEach(function (link) {
            link.classList.toggle('is-active', link.dataset.lnafTocLink === entry.target.id);
          });
        });
      }, { rootMargin: '-18% 0px -70% 0px', threshold: 0 });
      headings.forEach(function (heading) { observer.observe(heading); });
    }

    return headings;
  }

  function enhanceFaq(content) {
    var heading = Array.prototype.slice.call(content.querySelectorAll('h2')).find(function (candidate) {
      return /frequently asked questions|\bfaq\b/i.test(candidate.textContent || '');
    });
    if (!heading || heading.dataset.lnafFaqEnhanced === 'true') return;

    var first = heading.nextElementSibling;
    if (!first || first.tagName === 'H2') return;
    var wrapper = document.createElement('div');
    wrapper.className = 'lnaf-faq';
    wrapper.dataset.lnafFaq = '';
    heading.insertAdjacentElement('afterend', wrapper);

    var current = first;
    var answer = null;
    var foundQuestion = false;
    while (current && current.tagName !== 'H2') {
      var next = current.nextElementSibling;
      if (current.tagName === 'H3') {
        foundQuestion = true;
        var details = document.createElement('details');
        var summary = document.createElement('summary');
        answer = document.createElement('div');
        answer.className = 'lnaf-faq__answer';
        summary.textContent = current.textContent.trim();
        details.appendChild(summary);
        details.appendChild(answer);
        wrapper.appendChild(details);
        current.remove();
      } else if (answer) {
        answer.appendChild(current);
      } else {
        wrapper.appendChild(current);
      }
      current = next;
    }

    if (!foundQuestion) {
      while (wrapper.firstChild) heading.parentNode.insertBefore(wrapper.firstChild, wrapper);
      wrapper.remove();
      return;
    }
    heading.dataset.lnafFaqEnhanced = 'true';
  }

  function placeInlineModule(root, content, headings) {
    var inline = root.querySelector('[data-lnaf-inline]');
    if (!inline || inline.dataset.lnafPlaced === 'true') return;
    var target = headings.length > 2 ? headings[2] : headings[headings.length - 1];
    if (target && target.parentNode) target.parentNode.insertBefore(inline, target);
    inline.dataset.lnafPlaced = 'true';
  }

  function initProgress(root) {
    var article = root.querySelector('[data-lnaf-article]');
    var bar = root.querySelector('[data-lnaf-progress]');
    var label = root.querySelector('[data-lnaf-progress-text]');
    if (!article || !bar) return;
    var ticking = false;

    function update() {
      var top = article.getBoundingClientRect().top + window.scrollY;
      var distance = Math.max(article.offsetHeight - window.innerHeight * 0.55, 1);
      var value = Math.min(1, Math.max(0, (window.scrollY - top + window.innerHeight * 0.2) / distance));
      var percent = Math.round(value * 100);
      bar.style.width = percent + '%';
      if (label) label.textContent = percent + '%';
      ticking = false;
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
    update();
  }

  function initMobileBar(root) {
    var bar = root.querySelector('[data-lnaf-mobile-bar]');
    var shop = root.querySelector('[data-lnaf-shop]');
    if (!bar || !shop || !('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('is-obscured', entry.isIntersecting);
      });
    }, { threshold: 0.08 });
    observer.observe(shop);
  }

  function initTracking(root) {
    root.querySelectorAll('[data-lnaf-funnel-link]').forEach(function (link) {
      link.addEventListener('click', function () {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'article_funnel_click',
          article_handle: root.dataset.articleHandle || '',
          article_intent: root.dataset.funnelIntent || '',
          recommended_collection: root.dataset.funnelCollection || '',
          funnel_stage: link.dataset.funnelStage || '',
          destination_type: link.dataset.funnelDestination || '',
          destination_url: link.href
        });
      });
    });
  }

  function improveContentMedia(content) {
    content.querySelectorAll('img').forEach(function (image) {
      if (!image.hasAttribute('loading')) image.loading = 'lazy';
      if (!image.hasAttribute('decoding')) image.decoding = 'async';
    });
  }

  function init(root) {
    if (!root || root.dataset.lnafInitialized === 'true') return;
    root.dataset.lnafInitialized = 'true';
    var content = root.querySelector('[data-lnaf-content]');
    if (!content) return;

    var headings = buildToc(root, content);
    placeInlineModule(root, content, headings);
    enhanceFaq(content);
    improveContentMedia(content);
    initProgress(root);
    initMobileBar(root);
    initTracking(root);
  }

  function initAll(container) {
    (container || document).querySelectorAll('[data-lnaf]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
